var React = require('react');

function StatusClosed (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M0 0h23v23H0z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("g",{"key":0},[React.createElement("mask",{"fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("path",{"d":"M11.5 0C5.159 0 0 5.158 0 11.5 0 17.84 5.159 23 11.5 23 17.84 23 23 17.84 23 11.5 23 5.158 17.84 0 11.5 0","fill":"#D0021B","mask":"url(#b)","key":1})]),React.createElement("path",{"d":"M15.65 7.35a.885.885 0 0 0-1.25 0l-2.902 2.9-2.9-2.9a.885.885 0 0 0-1.25 1.25l2.9 2.9-2.9 2.9a.885.885 0 0 0 1.25 1.25l2.9-2.9 2.902 2.9a.882.882 0 0 0 1.25 0 .885.885 0 0 0 0-1.25l-2.9-2.9 2.9-2.9a.885.885 0 0 0 0-1.25","fill":"#FFF","key":1})])]);
}

StatusClosed.defaultProps = {"role":"presentation","viewBox":"0 0 23 23"};

module.exports = StatusClosed;

StatusClosed.default = StatusClosed;
